import { z } from 'zod'
import {
  KmhSchema,
  ZugmeldestelleSchema
} from '../../Generic/schema/generic.schema'

// Default constants
const DEFAULT_AUFTRAG_34_10 = {
  enabled: true,
  field_34_11_kmh: '',
  field_34_12_von: {
    art: '' as const,
    name: ''
  },
  field_34_13_bis: {
    art: '' as const,
    name: ''
  }
}

const DEFAULT_BEFEHL_34_FORM = {
  auftrag_34_10: DEFAULT_AUFTRAG_34_10
}

// Schema definitions
const Auftrag34_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_34_10.enabled),
    field_34_11_kmh: KmhSchema,
    field_34_12_von: ZugmeldestelleSchema,
    field_34_13_bis: ZugmeldestelleSchema
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_34_10))

// Base schema
const Befehl34FormSchemaBase = z
  .object({
    // Auftrag 34.10
    auftrag_34_10: Auftrag34_10Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_34_FORM))

export const Befehl34FormSchema = Befehl34FormSchemaBase

// Validation schema factory
export const createBefehl34FormValidationSchema = () => {
  return Befehl34FormSchemaBase
}

export type Befehl34FormData = z.infer<typeof Befehl34FormSchemaBase>
